$(document).ready(function(){
    $('.home-hero-slider-module-container').each(function(){
        var $self = $(this);
        var $sliderContainer = $self.find('.slider-container');

        $sliderContainer.slick(JSON.parse($sliderContainer.attr('slick-config') || '{}'));
    });
})